import { render, staticRenderFns } from "./ProjectDetailsCard.vue?vue&type=template&id=952a46de&"
import script from "./ProjectDetailsCard.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports